// work-header v1: 作品详情页头部组件

import React from 'react';

import WorkMediaGallery from './WorkMediaGallery';

/**
 * 作品详情页头部组件
 * @param {Object} workData - 作品数据
 * @param {Function} onBackClick - 返回按钮点击事件
 * @param {Function} onImageNavigation - 图片导航事件
 * @param {Object} navigationState - 作品导航状态
 * @param {string} className - 额外的CSS类名
 */
const WorkHeader = ({
  workData,
  onBackClick,
  onImageNavigation,
  navigationState,
  className = '',
}) => {
  return (
    <div className={`${className}`}>
      {/* Back Button */}
      <button
        onClick={onBackClick}
        className='flex items-center justify-center text-white mb-6 transition-all duration-200 relative z-10 bg-transparent px-4 py-2 rounded-lg border border-gray-300 w-full hover:bg-gradient-to-r hover:from-blue-500 hover:to-purple-600 hover:border-transparent font-bold'
      >
        <svg
          className='w-5 h-5 mr-2'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
        >
          <path
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={2}
            d='M15 19l-7-7 7-7'
          />
        </svg>
        BACK TO GALLERY
      </button>

      {/* Navigation Arrows for Works (not images) */}
      <div className='flex justify-between items-center mb-6'>
        <button
          onClick={navigationState?.navigateToPrevious}
          disabled={
            !navigationState?.hasPrevious && navigationState?.totalWorks <= 1
          }
          className='flex items-center px-4 py-2 bg-transparent rounded-lg border border-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed group text-white hover:bg-blue-200 hover:text-white'
          title='Previous work (←)'
        >
          <svg
            className='w-5 h-5 mr-2 text-white group-hover:text-blue-600 transition-colors duration-200'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M15 19l-7-7 7-7'
            />
          </svg>
          Previous Work
        </button>

        <button
          onClick={navigationState?.navigateToNext}
          disabled={
            !navigationState?.hasNext && navigationState?.totalWorks <= 1
          }
          className='flex items-center px-4 py-2 bg-transparent rounded-lg border border-gray-300 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed group text-white hover:bg-blue-200 hover:text-white'
          title='Next work (→)'
        >
          Next Work
          <svg
            className='w-5 h-5 ml-2 text-white group-hover:text-blue-600 transition-colors duration-200'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M9 5l7 7-7 7'
            />
          </svg>
        </button>
      </div>

      {/* 作品媒体画廊（支持图片和视频） */}
      <div className='mb-6'>
        {console.log('[WorkHeader] workData:', workData)}
        {console.log('[WorkHeader] videoUrl:', workData.videoUrl)}
        <WorkMediaGallery
          images={workData.allImages || [workData.mainImage]}
          videoUrl={workData.videoUrl || ''}
          workTitle={workData.title}
        />
      </div>
    </div>
  );
};

export default WorkHeader;
